import { gql } from "@apollo/client";

export const getPermissionPolicies = gql`
  query PermissionPolicies {
    PermissionPolicies {
      data
      total
    }
  }
`;
